'use strict';

import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { useFloating, offset, arrow } from '@floating-ui/react-dom';
import ClickAwayListener from 'react-click-away-listener';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cn from 'classnames/bind';

import { appSelectors, appOperations } from '@/state/domains/app';
import { usersSelectors, usersOperations } from '@/state/domains/users';

import { getHistory } from '@/history';
import Link from '@/views/common/Link';
import Logout from './Logout';

import s from './styles.scss'
import d from '../styles.scss'

const sx = cn.bind(s);
const dx = cn.bind(d);

export default connect(
	(state, props) => ({
		loggedInUser: usersSelectors.getLoggedInUser(state, props),
	}),
	{
		setModalOpen: appOperations.setModalOpen,
	}
)(
	({ loggedInUser, urlParams, pageId, setModalOpen }) => {

		const mounted = useRef(false);
		const arrowRef = useRef(null);
		const history = getHistory();

		useEffect(() => {
			mounted.current = true;

			return () => {
				mounted.current = false;
			};
		});

		const {
			x,
			y,
			reference,
			floating,
			strategy,
			update,
			middlewareData: {
				arrow: {
					x: arrowX,
					y: arrowY,
				} = {}
			},
		} = useFloating({
			placement: 'bottom-end',
			middleware: [
				offset(4),
				arrow({ element: arrowRef }),
			],
		});

		const [ menuOpen, setMenuOpen ] = useState(false);

		return (
			<ClickAwayListener
				onClickAway={ () => {
					if (mounted.current) {
						setMenuOpen(false);
					}
				}}
			>
				<div className={ s.userMenu }>
					<div
						className={ cn(sx('btn')) }
						ref={ reference }
						onClick={
							() => {
								setMenuOpen(!menuOpen);
								update();
							}
						}
					>
						<FontAwesomeIcon icon='user' />
					</div>
					{
						menuOpen && (
							<div
								ref={ floating }
								style={{
									position: strategy,
									top: y ?? 0,
									left: x ?? 0,
									zIndex: 20,
								}}
							>
								<div
									ref={ arrowRef }
									className={ s.arrow }
									style={{
										position: strategy,
										top: arrowY ?? -6,
										left: arrowX ?? 0,
									}}
								/>
								<div className={ s.menu }>
									<div className={ s.userLabel }>
										{ loggedInUser.username }
									</div>
									<ul className={ s.menuItems } >
										<li
											className={ s.menuLinkItem }
										>
											<Link
												className={ s.menuLink }
												to={{
													pathname: `/user/${ loggedInUser.username }`,
												}}
											>
												<div className={ s.listCell }>
													<FontAwesomeIcon icon='home' color='#444'/>
												</div>
												<div className={ s.listCell }>
													<label className={ s.label }>
														Home
													</label>
												</div>
											</Link>
										</li>
										<li
											className={ s.menuItem }
											onClick={
												() => setModalOpen('userSettings')
											}
										>
											<div className={ s.listCell }>
												<FontAwesomeIcon icon='gear' color='#444'/>
											</div>
											<div className={ s.listCell }>
												<label className={ s.label }>Settings</label>
											</div>
										</li>
										<li
											className={ s.menuLinkItem }
										>
											<a
												className={ s.menuLink }
												onClick={
													e => {
														e.preventDefault();
														localStorage.removeItem('user');
														window.location.replace('/logout');
													}
												}
											>
												<div className={ s.listCell }>
													<FontAwesomeIcon icon='sign-out-alt' color='#444'/>
												</div>
												<div className={ s.listCell }>
													<label className={ s.label }>Logout</label>
												</div>
											</a>
										</li>
									</ul>
								</div>
							</div>
						)
					}
				</div>
			</ClickAwayListener>
		);
	}
);
